import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContentCustomer } from '../../Common/Table/tableContent';
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import services from '../service';
import { search, SearchFeild } from '../../Common';
import MenuItem from '@material-ui/core/MenuItem';
import $ from 'jquery';
import { CustomerBiometricSchemaObject } from '../CustomerSchema';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';

import Joi from '@hapi/joi'
import { TextField, Grid } from '@material-ui/core';
import FileBase64 from 'react-file-base64';
import FormHelperText from '@material-ui/core/FormHelperText';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { CommonEncryptParam } from '../../../../utils/CommonParams';

import { AlertDialog } from '../../../Common/AlertDialog';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from "@material-ui/core/Typography";
import { Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import { CommonDecryptParam } from "../../../../utils/CommonParams";
import CircularProgress from "@material-ui/core/CircularProgress";

const screenCode = 'CUSTOMER'
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: "#fffff",
    },
    rootx: {
        display: "flex",
        "& > * + *": {
            marginLeft: theme.spacing(5),
        },
    },

    bar: {
        backgroundColor: "#424242",
    },
    txt: {
        color: "#ffffff",
        backgroundColor: "#424242",
    },
    paper: {
        backgroundColor: "#424242",
    },

    large: {
        width: theme.spacing(20),
        height: theme.spacing(20),
    },
    title: {
        fontSize: 14,
    },
    card1: {
        flexGrow: 1,
        backgroundColor: "#ffffff",
        paddingInlineStart: "10px",
        borderRadius: "10px",
        boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",
        maxHeight: 300,
        height: 150,
    },
    card2: {
        borderRadius: "10px",
        backgroundColor: "#fffff",
        paddingInlineStart: "10px",
        boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",

        height: 150,
    },

    card3: {
        borderRadius: "10px",
        backgroundColor: "#fffff",
        paddingInlineStart: "10px",
        boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",

        height: 150,
    },
    card4: {
        borderRadius: "10px",
        backgroundColor: "#fffff",
        paddingInlineStart: "10px",
        boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",

        height: 250,
    },
    centertitle: {
        color: "#000000",
        fontSize: 30,
        textAlign: "center",
    },

    profImage: {
        paddingLeft: "50px",
    },
    centertitleCurrency: {
        fontSize: 30,
        textAlign: "center",
        color: "#000000",
    },
}));
export function Listing(props) {
    const classes = useStyles();
    const [customers, setCustomers] = useState([]);
    const [customerBiometrics, setcustomerBiometrics] = useState({
        groupID: 0,
        operationEntityId: 0,
        registrationNumber: '',
        NIC: ''

    });
    const [openDialog, setOpenDialog] = React.useState(false);
    const [supplierBio, setSupplierBio] = useState([]);
    const [supplierDetails, setSupplierDetails] = useState({});

    const [operationEntities, setOperationEntities] = useState([]);
    const [groups, setGroups] = useState()
    const [isTableHide, setIsTableHide] = useState(true);
    const contentRowNames = ["customerCode", "firstName"]
    const [files, setFiles] = useState({});
    const [productImage, setProductImage] = useState({});
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const schema = Joi.object(CustomerBiometricSchemaObject).options({ allowUnknown: true });
    const screenData = "cusScreen";

    // //POPUp start
    const [message, setMessage] = useState("Edit Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    // //popUP end

    useEffect(() => {
        trackPromise(
            getPermissions())
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [customerBiometrics.groupID]);

    // useEffect(() => {
    //     trackPromise(
    //         handleSearch()
    //         )
    // }, [customerBiometrics.operationEntityId]);

    useEffect(() => {
        getPermissions();
    }, []);




    //POPUP function
    async function handleDelete() {
        setEnableConfirmMessage(true);
    }
    function confirmData(y) {
        if (y) {
            onCancelClick();
        }
    }

    //popUP End

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCUSTOMERLISTING');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITCUSTOMER');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setcustomerBiometrics({
            ...customerBiometrics,
            groupID: token.groupID,
            operationEntityId: token.operationEntityID
        });

        getAllGroups();
    }
    async function getOperationEntities() {
        var data = await services.getAllOperationEntitiesForDropDown(customerBiometrics.groupID);
        setOperationEntities(data)

    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getAvatar(customer) {
        var result = await services.getBiometrics(customer.customerID, 1);

        if (result.length == 0) {
            setErrors({});
        } else {
            let model = {
                createdBy: result[0].createdBy,
                createdDate: result[0].createdDate,
                customerBiometricData: result[0].customerBiometricData,
                customerBiometricDataTypeID: result[0].customerBiometricDataTypeID,
                customerBiometricID: result[0].customerBiometricID,
                customerID: result[0].customerID,
                isActive: result[0].isActive,
                isDefault: result[0].isDefault,
            }
            setSupplierBio(model);
        }


    }

    async function getDetails(customer) {
        const result = await services.getCustomerByID(customer.customerID);
        setSupplierDetails(result);
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    function handleClick(customer) {
        props.history.push({
            pathname: 'customer/customerBiometricsAddEdit/' + CommonEncryptParam(customer.customerID.toString()),
            data: customer,
            edit: true
        })
    }
    function handleClick2(customer) {

        props.history.push({
            pathname: 'customer/CustomerCardAddEdit',
            data: customer,
            edit: true
        })
    }

    function handleClickView(customer) {
        props.history.push({
            pathname: 'supplierProfile/' + CommonEncryptParam(customer.customerID.toString()),
            data: customer,
            edit: true,
            screen: screenData
        })
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    async function handleSearch(e) {
        if (e !== undefined) {
            const errorMessages = validate(schema, customerBiometrics);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }


        const response = await services.GetCustomerDetails(customerBiometrics);
        response.forEach((customer) => {
            customer.firstName = customer.firstName + ' ' + customer.lastName
        });

        setIsTableHide(false);
        destroyDataTable();
        setCustomers(response);
        createDataTable();


    }

    function setAvatar() {
        if (supplierBio == null || supplierBio.length == 0) {
            return (
                <div className={classes.profImage}>
                    <Avatar alt="Remy Sharp" className={classes.large} />
                </div>
            );
        } else {
            return (
                <div className={classes.profImage}>
                    <Avatar
                        alt="Remy Sharp"
                        className={classes.large}
                        src={supplierBio.customerBiometricData}
                    />
                </div>
            );
        }
    }

    function loadProfileData() {
        if (supplierDetails != null) {
            return (
                <div>
                    <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                    >
                        {supplierDetails.firstName +
                            " " +
                            supplierDetails.secondName +
                            " " +
                            supplierDetails.lastName}
                    </Typography>
                    <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                    >
                        {supplierDetails.address1 + " " + supplierDetails.address2}
                    </Typography>
                    <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                    >
                        {supplierDetails.nic}
                    </Typography>
                    <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                    >
                        {supplierDetails.mobileNo}
                    </Typography>
                </div>
            );
        } else {
            return (
                <div className={classes.rootx}>
                    <CircularProgress color="primary" />
                </div>
            );
        }
    }




    function handleChange(e) {
        const target = e.target
        const value = (target.name === 'isActive' || target.name === 'isErpEnabled') ? target.checked : target.value


        const error = { ...errors }
        const errorMessage = validateProperty(target, CustomerBiometricSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setcustomerBiometrics({
            ...customerBiometrics,
            [e.target.name]: value
        })

        setErrors(error)
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setcustomerBiometrics({
            ...customerBiometrics,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityId: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            registrationNumber: '',
            NIC: '',
        });
        destroyDataTable();
        setCustomers([]);
        setIsTableHide(true);
    }

    function onCancelClick() {
        setErrors([]);
        clearState();
    }

    function getFiles(files) {

        setFiles(files);
        setProductImage(files.base64)

    }
    const handleClose = () => {
        setSupplierBio({});
        setOpenDialog(false);
    };

    function handleClickOpen(customers) {
        trackPromise(getAvatar(customers));
        trackPromise(getDetails(customers));
        setOpenDialog(true);
    };





    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Customer"
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    buttonText="Add Customer"
                                    path="Customer/customerCardAddEdit" />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSearch(e)}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={customerBiometrics.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityId"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityId"
                                            value={customerBiometrics.operationEntityId}
                                            onChange={(e) => handleChange(e)}>

                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntities)}
                                        </Select>
                                        {errors["operationEntityId"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityId"]}</FormHelperText>}
                                    </div>


                                </div>
                                <div className="form-group row">


                                    <div className="col-md">
                                        <TextField fullWidth label="Registration No"
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={customerBiometrics.registrationNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["registrationNumber"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["registrationNumber"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md">

                                        <TextField fullWidth label="NIC"
                                            name="NIC"
                                            id="NIC"
                                            value={customerBiometrics.NIC}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["NIC"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["NIC"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input

                                        type="button"
                                        className="btn btn-primary"

                                        value="Search"
                                        onClick={(e) => trackPromise(handleSearch(e))}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={clearState}
                                    />

                                </div>

                            </form>
                            <div className="table-responsive row-top-gap" >
                                <table id="example" className="display dataTable no-footer" hidden={isTableHide}>
                                    <thead>
                                        <tr>

                                            <th>Customer Code</th>
                                            <th>Customer Name</th>
                                            <th>View</th>
                                            {permissionList.isAddEditEnabled ? <th>Actions</th> : null}


                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContentCustomer
                                            data={customers}
                                            contentRowNames={contentRowNames}
                                            handleClick={handleClick}
                                            hasEdit={permissionList.isAddEditEnabled}
                                            handleClickView={handleClickOpen}
                                            actiontype={"CustomerBiometrics"}
                                            handleClick2={handleClick2}
                                        />
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* popUP Start */}
            <div hidden={true}>
                <Grid item>
                    <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                        discription={"Are you sure want to Edit "} setViewPopup={setEnableConfirmMessage} />
                </Grid>
            </div>
            {/* popUP Start */}
            <div hidden={true}>
                <div>

                    <LoadingSpinerComponent />
                    <Dialog open={openDialog} onClose={handleClose} fullWidth={true}
                        aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title" className={classes.title}><b>Supplier Profile</b>{" "}</DialogTitle>
                        <DialogContent>
                            <Box>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        {setAvatar()}
                                    </div>

                                    <div className="col-md pb-1">
                                        {loadProfileData()}
                                    </div>


                                </div>
                            </Box>

                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to Edit "} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
            </div>
            {/* popup end */}
        </Fragment>
    )

}
